import React from 'react';
import Box from '@mui/material/Box';

// Single shared arrow for "link →" affordances across the site.
// Inherits the link's color via currentColor.
export function ArrowIcon({ size = 18, sx }) {
    return (
        <Box
            component="svg"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            sx={{
                width: size,
                height: size,
                display: 'inline-block',
                verticalAlign: 'middle',
                flexShrink: 0,
                ...sx,
            }}
        >
            <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Box>
    );
}
